export default __webpack_public_path__ + "static/media/logo-big.769ceccd.png";